<template>
  <div class="editor">
    <floor-selector></floor-selector>
    <zoom-slider></zoom-slider>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import FloorSelector from './FloorSelector'
import ZoomSlider from './ZoomSlider'
import { app, grid } from '../display'

export default {
  components: {
    FloorSelector,
    ZoomSlider,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      floor: state => state.editor.floor,
      zoom: state => state.editor.zoom,
      items: state => state.madori.items,
    }),
  },
  watch: {
    floor(newFloor) {
      grid.changeFloor(newFloor)
    },
    zoom(newZoom) {
      grid.changeZoom(newZoom)
    },
  },
  mounted() {
    this.$el.appendChild(app.view)

    app.renderer.resize(this.$el.clientWidth, this.$el.clientHeight)
    app.stage.pivot.set(app.screen.width/2 * -1, app.screen.height/2 * -1)

    // window.addEventListener('resize', this.screenResize)

    this.initialize()
  },
  methods: {
    ...mapActions('item', [
      'unsetGrabbingConfig',
      'hideItemShadow',
      'showItemShadow',
    ]),
    ...mapActions('madori', [
      'addItem',
      'gridSettled',
    ]),
    initialize() {
      app.view.addEventListener('mouseenter', event => {
        let shadow_config = this.$store.getters['item/itemShadowConfig']
        if (shadow_config) {
          this.hideItemShadow()
          if (grid.activeLayer.children.length > 0) {
            grid.activeLayer.children.forEach(activeInstance => activeInstance.alpha = 1)
          }
        }
        let grabbing_config = this.$store.getters['item/grabbingConfig']
        if (grabbing_config) {
          this.unsetGrabbingConfig()
          this.addItem({ config: grabbing_config })
            .then(instance => instance.dragStart())
        }
      })
      app.view.addEventListener('mouseleave', event => {
        let shadow_config = this.$store.getters['item/itemShadowConfig']
        if (shadow_config) {
          this.showItemShadow()
          if (grid.activeLayer.children.length > 0) {
            grid.activeLayer.children.forEach(activeInstance => activeInstance.alpha = 0)
          }
        }
      })

      const getConfigById = this.$store.getters['item/configById']
      const roomUpdate = (room, children) => {
        return new Promise(resolve => {
          if (children.length > 0) {
            return Promise.all(children.map(child => {
              return this.addItem({
                config: getConfigById(child.config_id),
                item: child,
              }).then(instance => {
                if (instance.config.type == 'room') {
                  // room の入れ子は無い
                } else {
                  return itemUpdate(instance)
                }
              })
            })).then(() => {
              room.update(true)
              resolve(room)
            })
          } else {
            room.update(true)
            resolve(room)
          }
        })
      }
      const itemUpdate = (item) => {
        return new Promise(resolve => {
          item.update(true)
          if (item.loaded == false) {
            item.once('loaded', () => resolve(item))
          } else {
            resolve(item)
          }
        })
      }
      let promises = this.items.map(items => {
        return items.filter(item => item.parent_id == 0).map(item => {
          return this.addItem({
            config: getConfigById(item.config_id),
            item: item,
          }).then(instance => {
            if (instance.config.type == 'room') {
              let children = items.filter(child => child.parent_id == item.id)
              return roomUpdate(instance, children)
            } else {
              return itemUpdate(instance)
            }
          })
        })
      })

      Promise.all(_.flatten(promises))
        .then(() => {
          grid.updateArea()
          this.gridSettled()
        })

    },
    // screenResize() {
    //   let oldWidth = app.renderer.width
    //   let oldHeight = app.renderer.height
    //   app.renderer.resize(this.$el.clientWidth, this.$el.clientHeight)
    //   window.requestAnimationFrame(() => {
    //     app.render()
    //     grid.positionResize(app.screen, app.renderer.width - oldWidth, app.renderer.height - oldHeight)
    //   })
    // },
  },
}
</script>



// WEBPACK FOOTER //
// assets/js/components/Editor.vue